// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2FHSl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__11fjb","obliqueLine":"membershipbadge_obliqueLine__2hfNG"};